<h1
  class="input-stretchy tw-mr-2.5"
  contenteditable
  [formControl]="inputControl"
  (keydown)="inputKeyDown($event)"
  (blur)="_setNonEditable()"
  (click)="setEditable()"
  [attr.aria-label]="ariaLabel"
  name="stretchyInput"
  tabindex="0"
></h1>
